import axios from 'axios';
import type { RecordingsSpoaDocument } from '../components/RecordingsSpoaModal';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3009/api/v1';

export async function fetchSpoaCasesForContext(
  contextDate: string,
  token: string
): Promise<RecordingsSpoaDocument[]> {
  const res = await axios.get<{ success?: boolean; data?: RecordingsSpoaDocument[] }>(
    `${API_URL}/spoa/cases`,
    {
      params: { contextDate },
      headers: { Authorization: `Bearer ${token}` },
    }
  );
  const list = res.data?.data;
  return Array.isArray(list) ? list : [];
}

export async function replaceSpoaCasesForContext(
  contextDate: string,
  cases: RecordingsSpoaDocument[],
  token: string
): Promise<void> {
  await axios.put(
    `${API_URL}/spoa/cases`,
    { contextDate, cases },
    { headers: { Authorization: `Bearer ${token}` } }
  );
}
